import { API_URL } from "../config";
import { useAuth } from './component/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect } from "react";

const MagicLogin = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const { magicToken } = useParams();

    useEffect(() => {
        fetch(API_URL + `/magic-link/${magicToken}`)
            .then((response) => {
                if (!response.ok) {
                    navigate('/');
                    return;
                }
                return response.json();
            })
            .then((data) => {
                if (data && data.message === 'Login successful') {
                    login(data);
                    navigate('/account');
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                navigate('/');
            });
    }, []);

    return (
        <div>Loading...</div>
    )
}

export default MagicLogin;
